/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * A segment of text to highlight
 */
export interface HighlightSegment {
  /** Start words or tokens of the segment to highlight */
  start: string;
  /** End words or tokens of the segment to highlight */
  end: string;
}
